import { Loader2 } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { type Track, useAdminArchiveTrack } from "@/lib/api";

interface Props {
  track: Track | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TrackArchiveDialog({ track, open, onOpenChange }: Props) {
  const archiveMutation = useAdminArchiveTrack();
  const [error, setError] = useState("");

  const handleArchive = async () => {
    if (!track) {
      return;
    }
    setError("");
    try {
      await archiveMutation.mutateAsync({ trackId: track.id });
      onOpenChange(false);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to archive track.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Archive track</DialogTitle>
          <DialogDescription>
            Archive <strong>{track?.name}</strong>? It will no longer appear on the dashboard.
          </DialogDescription>
        </DialogHeader>
        {error && <p className="text-destructive text-sm">{error}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={handleArchive}
            disabled={archiveMutation.isPending}
          >
            {archiveMutation.isPending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Archive"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
